import React, {useState, useCallback, useEffect}  from 'react'
import { Modal, Button } from 'rsuite';
import { QuestionIcon, eyeSVG, lineSVG} from '../svg/iconsSvg';
import InfoMsg from '../png/InfoMsg.png';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const preventEnterReload = (ev) => {
    if (ev.key === 'Enter') {
        // Do code here
        ev.preventDefault();
      }
}


export const NuInsInputTextLabel = ({onChange, onBlur, placeholder, disabled, validationType, slice, value, error, errorMsg, styles}) => {

    value = value ? value : '';

    const [updatedValue,setValue] = useState(value);

    useEffect(()=> {
        if(value !== updatedValue) setValue(value ? value : '')
    }, [value, updatedValue])

    const onChangeHandler = (event) => {  
        let newData = event.target.value;

        switch (validationType) {
            case 'color':
                newData = newData.replace(/[a-zA-Z0-9]/, "");
                break;
            case 'vin':
                newData = newData.replace(/[^0-9a-zA-Z]/, "");
                break;
            case 'plate':
                newData = newData.replace(/^[^a-zA-ZаАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ]/, "");   
                newData = newData.replace(/[^0-9a-zA-ZаАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ]/, "");
                break; 
            default:
                //newData = newData;
                break;
          }

        newData = slice ? newData.slice(0, slice) : newData;  
        setValue(newData )
        if(onChange) onChange(newData);
    }

    return(            
        <div className="nuins_input_field" style={styles}>
            <form  noValidate autoComplete="off" >
                <TextField  id={placeholder} 
                error={error}
                disabled={disabled}
                label={placeholder} 
                value={updatedValue}
                onKeyPress={preventEnterReload}
                onChange={onChangeHandler}
                onBlur={onBlur}
                helperText=""/>
                {error ? <FormHelperText error={error}>{errorMsg ? errorMsg : null}</FormHelperText> : null}
             </form>
       </div>        
    )
}

export const NuInsInputNumLabel = ({onChange, onBlur, placeholder, disabled, validationType, slice, value, error, errorMsg, styles}) => {

    value = value ? value : '';

    const [updatedValue,setValue] = useState(value);

    useEffect(()=> {
        if(value !== updatedValue) setValue(value ? value : '')
    }, [value, updatedValue])

    const onchangeHandler = (event) => { 
        let newData = event.target.value;

        switch (validationType) {
            case 'noZero':
                newData = newData.replace(/^[0]/, "");
                break;
            default:
                break;
          }

        newData = slice ? newData.replace(/[^0-9]/,"").slice(0,slice) : newData.replace(/[^0-9]/,"")

        setValue(newData )
        if(onChange) onChange(newData);
    }

    return (            
        <div className="nuins_input_field" style={styles}>
            <form  noValidate autoComplete="off">
                <TextField  id={placeholder} 
                error={error}
                disabled={disabled}
                label={placeholder} 
                value={updatedValue}
                onKeyPress={preventEnterReload}
                onChange={onchangeHandler}
                onBlur={onBlur}
                helperText=""/>
                {error ? <FormHelperText error={error}>{errorMsg ? errorMsg : null}</FormHelperText> : null}
            </form>
       </div>        
    )
}



export const NuInsSelectLabel = ({onChange, onBlur, placeholder, options, disabled, value, error, errorMsg, styles}) => {

    value = value ? value : '';

    const [updatedValue,setValue] = useState(value);

    const useStyles = makeStyles((theme) => {
        return {
            formControl: {
                minWidth: '100%'
            },
            selectEmpty: {
        //   marginTop: theme.spacing(1),
            },
        }
    });
    
    const classes = useStyles();

    const onValueChange = useCallback(() => {setValue(value)}, [value]);

    useEffect(() => {
        onValueChange();
    }, [onValueChange])

    const onchangeHandler = (event) => {        

        let newData = event.target.value;
    //console.log('select', newData)
        setValue(newData);
        if(onChange) onChange(newData);
    }
     // data format supllied to be in the format
    // const optionsExample = [{
    //     "label": "Monday",
    //     "value": "Monday",
    //   },
    //   {
    //     "label": "Sunday",
    //     "value": "Sunday",
    //   }]
      

    return(            
        <div className="nuins_input_field" style={styles}>
            <FormControl className={classes.formControl}  error={error}>
                <InputLabel id="demo-simple-select-label">{placeholder}</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={updatedValue}
                disabled={disabled}
                onChange={onchangeHandler}
                onBlur={onBlur}
                input={<Input />}
                >
                {options.map((name) => (
                    <MenuItem key={name.value} value={name.value} >
                    {name.label}
                    </MenuItem>
                ))}
                </Select>
                {error ? <FormHelperText>{errorMsg ? errorMsg : null}</FormHelperText> : null}
            </FormControl>      
       </div>        
    )
}

export const NuInsInputDateLabel = ({placeholder, value, onChange, error, errorMsg, styles, minDate, maxDate}) => {

    const [open, setOpen] = useState(false);

    const onchangeHandler = (date) => { 
        if(!date) return; 
        if(onChange) onChange(date);
    }

    return (            
        <div className="nuins_input_field" style={styles}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                    open={open}
                    onClick={()=>setOpen(true)}
                    onClose={() => setOpen(false)}
                    disableToolbar
                    variant="inline"
                    format="YYYY-MM-DD"
                    margin="normal"
                    id="date-picker-dialog"
                    label={placeholder}
                    value={value}
                    onChange={onchangeHandler}
                    autoOk={true}
                    minDate={minDate}
                    maxDate={maxDate}
                    error={error}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
                 {error ? <FormHelperText error>{errorMsg ? errorMsg : null}</FormHelperText> : <></>}
             </MuiPickersUtilsProvider>      
       </div>        
    )
}

export const NuInsInputNumInfoLabel = ({onChange, placeholder, validationType, slice, value, error, errorMsg, styles}) => {

    value = value ? value : '';

    const [updatedValue,setValue] = useState(value);
    const [showInfo,setShowInfo] = useState(false);

    const openInfo  = () => setShowInfo(true);
    const closeInfo = () => setShowInfo(false);

    const onchangeHandler = (event) => { 
        let newData = event.target.value;

        switch (validationType) {
            case 'noZero':
                newData = newData.replace(/^[0]/, "");
                break;
            default:
                break;
          }

        newData = slice ? newData.replace(/[^0-9]/,"").slice(0,slice) : newData.replace(/[^0-9]/,"")

        setValue(newData )
        if(onChange) onChange(newData);
    }

    return (            
        <div className="nuins_input_field" style={styles}>
            <form className="nuins_input_body"  noValidate autoComplete="off">
                <TextField  id="standard-basic"
                error={error}
                label={placeholder} 
                value={updatedValue}
                onKeyPress={preventEnterReload}
                onChange={onchangeHandler}
                helperText=""/>
                {error ? <FormHelperText error={error}>{errorMsg ? errorMsg : null}</FormHelperText> : null}
                <div className="nuins_input_icon" onClick={openInfo}>                
                    <i><QuestionIcon size="16" style={{marginLeft: '2px'}}/></i>
                </div>
                <Modal size="xs" show={showInfo} onHide={closeInfo}>
                    <Modal.Header>
                        <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>  
                            <img src={InfoMsg}  alt="Shows the Id Location" style={{width:"300px", minHeight:"70vh"}}/>    
                        </div>
                    </Modal.Body>
                    <br/>
                    <Modal.Footer>
                        <Button onClick={closeInfo} appearance="subtle">
                        Ok
                        </Button>
                    </Modal.Footer>
                </Modal>
            </form>

       </div>        
    )
}

/******************************************************************** */
export const NuInsInputPasswordLabel = ({onChange, onBlur, placeholder, validationType, slice, value, error, errorMsg, styles}) => {

    value = value ? value : '';

    const [updatedValue, setValue] = useState(value);

    const [show, setShow] = useState(false)

    useEffect(()=> {
        if(value !== updatedValue) setValue(value ? value : '')
    }, [value, updatedValue])

    const onChangeHandler = (event) => {  
        let newData = event.target.value;

        switch (validationType) {
            case 'vin':
                newData = newData.replace(/[^0-9a-zA-Z]/, "");
                break;
            default:
                //newData = newData;
                break;
          }

        newData = slice ? newData.slice(0, slice) : newData;  
        setValue(newData )
        if(onChange) onChange(newData);
    }

    return(            
        <div className="nuins_input_field" style={styles}>
            <form  noValidate autoComplete="off" >
                <div style={{position:"relative"}}>
                <TextField  id={placeholder} 
                            type={ show ? "text" :"password"}
                            error={error}
                            label={placeholder} 
                            value={updatedValue}
                            onKeyPress={preventEnterReload}
                            onChange={onChangeHandler}
                            onBlur={onBlur}
                            helperText=""> </TextField>
                {/* <Icon icon="eye" style={{zIndex:30,position:"absolute",top:"30px",right:"5px"}}/>  */}
                <div className="password-icon" onClick={() => setShow(!show)}> {eyeSVG}</div>
                { show && <div className="password-icon_line" onClick={() => setShow(!show)}> {lineSVG}</div> }
                </div>
                {error ? <FormHelperText error={error}>{errorMsg ? errorMsg : null}</FormHelperText> : null}
             </form>
             
       </div>        
    )
}

export const NuInsSelectGroupLabel = ({onChange, onBlur, placeholder, options, disabled, value, error, errorMsg}) => {

    value = value ? value : '';

    const [updatedValue,setValue] = useState(value);

    const useStyles = makeStyles((theme) => ({
        formControl: {
          minWidth: '100%',
        },
        selectEmpty: {
       //   marginTop: theme.spacing(1),
        },
      }));
    
    const classes = useStyles();

    const onValueChange = useCallback(() => {setValue(value)}, [value]);

    useEffect(() => {
        onValueChange();
    }, [onValueChange])

    const onchangeHandler = (event) => { 

        let newData = event.target.value;
    //console.log('select', newData)
        setValue(newData);
        if(onChange) onChange(newData);
    }
     // data format supllied to be in the format
    // const optionsExample = [{
    //     "label": "Monday",
    //     "value": "Monday",
    //      'key' : 'Monday'
    //   },
    //   {
    //     "label": "Sunday",
    //     "value": "Sunday",
    //      'key' : 'Sunday'
    //   }]
      

    return(            
        <div className="nuins_input_field">
            <FormControl className={classes.formControl}  error={error}>
                <InputLabel id="demo-simple-select-label">{placeholder}</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={updatedValue}
                disabled={disabled}
                onChange={onchangeHandler}
                onBlur={onBlur}
                input={<Input />}
                native={true}
                >
                {options.map((name) => (
                    <optgroup label={name.label} key={name.key}>
                        <option value={name.value}>{name.value}</option>
                    </optgroup>
                ))}
                </Select>
                {error ? <FormHelperText>{errorMsg ? errorMsg : null}</FormHelperText> : null}
            </FormControl>      
       </div>        
    )
}

const NuInsInputNumCodeLabel = ({onChange, onBlur, id, placeholder, validationType, slice, value, error, errorMsg}) => {

    value = value ? value : '';

    const [updatedValue,setValue] = useState(value);

    useEffect(()=> {
        //console.log('v',value,'uv', updatedValue)
        if(value !== updatedValue) setValue(value ? value : '')
    }, [value, updatedValue])

    const onchangeHandler = (event) => { 
        let newData = event.target.value;

        switch (validationType) {
            case 'noZero':
                newData = newData.replace(/^[0]/, "");
                break;
            default:
                break;
          }

        newData = slice ? newData.replace(/[^0-9]/,"").slice(0,slice) : newData.replace(/[^0-9]/,"")

        setValue(newData )
        if(onChange) onChange(newData);
    }

    return (            
        <div className="nuins_input_field nuins_input_field_code">
            <form  noValidate autoComplete="off">
                <TextField  id={id} 
                error={error}
                label={placeholder} 
                value={updatedValue}
                onKeyPress={preventEnterReload}
                onChange={onchangeHandler}
                onBlur={onBlur}
                helperText=""/>
                {error ? <FormHelperText error={error}>{errorMsg ? errorMsg : null}</FormHelperText> : null}
            </form>
       </div>        
    )
}

export const NuInsSmsCodeLabel = ({onChange, onBlur, placeholder, options, disabled, value, error, errorMsg}) => {

    const [code, setCode] = useState([]);

    const focusNextField = (fieldIndex, data, newCode) => {
        if( fieldIndex >=6 || !data ) return;
        const id = `sms-${fieldIndex+1}`;
        const el = document.getElementById(id);
        el.focus();
        newCode=newCode.slice();
        newCode[fieldIndex] = '';
        setCode(newCode);
      };

    const onChangeHandler = (data, fieldIndex) => {
        if(!fieldIndex) return;
        const newCode = code.slice();
        newCode[fieldIndex-1] = data;
        setCode(newCode);
        focusNextField(fieldIndex, data, newCode);
        if(onChange) onChange(newCode.join(''));
    }

    return (
        <div className="sms-code-container">
            <NuInsInputNumCodeLabel onChange={(data)=>onChangeHandler(data, 1)} value={code[0]} id='sms-1' slice={1}/>
            <NuInsInputNumCodeLabel onChange={(data)=>onChangeHandler(data, 2)} value={code[1]}  id='sms-2' slice={1}/>
            <NuInsInputNumCodeLabel onChange={(data)=>onChangeHandler(data, 3)} value={code[2]}  id='sms-3' slice={1}/>
            <NuInsInputNumCodeLabel onChange={(data)=>onChangeHandler(data, 4)} value={code[3]}  id='sms-4' slice={1}/>
            <NuInsInputNumCodeLabel onChange={(data)=>onChangeHandler(data, 5)} value={code[4]}  id='sms-5' slice={1}/>
            <NuInsInputNumCodeLabel onChange={(data)=>onChangeHandler(data, 6)} value={code[5]}  id='sms-6' slice={1}/>
        </div>
    )
}